import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import ThemeProvider from "./components/theme/ThemeProvider";
import Navbar from "./components/layout/Navbar";
import Hero from "./components/layout/Hero";
import Menu from "./components/menu/Menu";
import LunchMenu from "./components/menu/LunchMenu";
import BookingSection from "./components/booking/BookingSection";
import Footer from "./components/layout/Footer";
import React, { Suspense, lazy } from "react";
import RestaurantMap from "./components/map/RestaurantMap";
import WhatsAppButton from "./components/contact/WhatsAppButton";
import OpeningHoursBar from "./components/layout/BookingBanner";
import BookingErrorBanner from "./components/layout/BookingErrorBanner";
import ClosureBanner from "./components/layout/ClosureBanner";

// Code-split admin pages so they don't ship in the public bundle
const AdminLogin = lazy(() => import("./pages/AdminLogin"));
const AdminDashboard = lazy(() => import("./pages/AdminDashboard"));

export default function App() {
  // Use a more reliable way to detect environment
  // Check for development environment
  const isDevEnvironment = () => {
    return window.location.hostname === 'localhost' ||
           window.location.hostname === '127.0.0.1';
  };

  return (
    <Router>
      <ThemeProvider>
        <Routes>
          <Route
            path="/admin"
            element={
              <Suspense fallback={null}>
                <AdminLogin />
              </Suspense>
            }
          />
          <Route
            path="/admin/dashboard"
            element={
              <Suspense fallback={null}>
                <AdminDashboard />
              </Suspense>
            }
          />
          <Route
            path="/"
            element={
              <div className="min-h-screen bg-white dark:bg-gray-900 transition-colors">
                {/* Display environment-specific banners based on hostname */}
                {isDevEnvironment() && (
                  <div className="bg-yellow-100 text-yellow-800 text-center text-sm py-1">
                    Development Environment (Test Only)
                  </div>
                )}
                {/* Special temporary banners */}
                {/* <BookingErrorBanner /> */}
                {/* <ClosureBanner /> */}
                <OpeningHoursBar />
                <Navbar />
                <Hero />
                <LunchMenu />
                <Menu />
                <BookingSection />
                <RestaurantMap />
                <Footer />
                <WhatsAppButton />
              </div>
            }
          />
        </Routes>
      </ThemeProvider>
    </Router>
  );
}
